<script setup lang="ts">
import Tag from 'primevue/tag';
</script>
<template>
  <div :class="$style.content">
    <h3 :class="$style.content__caption">
      Capital that fits your business. Find your best funding structure.
    </h3>

    <div :class="$style.container">
      <div :class="$style.card">
        <div :class="$style.card__header">
          <Tag
            value="Continuous"
            severity="success"
            :class="$style.card__header__tag"
          />
          <h3 :class="$style.card__header__title">Rolling Funding</h3>
          <h3 :class="$style.content__section__title">Why it works</h3>
          <div :class="$style.content__section__copy">
            Available funding capacity automatically replenishes with each
            payment, giving you ongoing flexibility to plan quarterly, not just
            around one-time funding events.
          </div>
        </div>
        <div :class="$style.card__footer">
          <h4 :class="$style.card__footer__title">Best for</h4>
          <ul :class="$style.card__list">
            <li><i class="pi pi-check"></i><span>Ongoing campaigns</span></li>
            <li><i class="pi pi-check"></i><span>Inventory purchases</span></li>
            <li><i class="pi pi-check"></i><span>Recurring expenses</span></li>
            <li><i class="pi pi-check"></i><span>Ad spend</span></li>
          </ul>
        </div>
      </div>

      <div :class="$style.card">
        <div :class="$style.card__header">
          <Tag
            value="One-time"
            severity="info"
            :class="$style.card__header__tag"
          />
          <h3 :class="$style.card__header__title">Fixed Funding</h3>
          <h3 :class="$style.content__section__title">Why it works</h3>
          <div :class="$style.content__section__copy">
            Designed for significant growth, approved tranches allow you to
            secure all the capital needed for growth initiatives, seasonal ramps
            and manage cash flow.
          </div>
        </div>
        <div :class="$style.card__footer">
          <h4 :class="$style.card__footer__title">Best for</h4>
          <ul :class="$style.card__list">
            <li><i class="pi pi-check"></i><span>Strategic planning</span></li>
            <li><i class="pi pi-check"></i><span>Seasonal spikes</span></li>
            <li><i class="pi pi-check"></i><span>Product launches</span></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less" module>
.content {
  height: 526px;

  .content__caption {
    color: var(--neutral-grey-500, #303032);
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 32px;
  }

  .content__section__title {
    margin-bottom: 8px;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
  }

  @media (max-height: 900px) {
    height: 478px;
  }
}

.card__header__title {
  margin-bottom: 16px;
  margin-top: 24px;
  color: var(--color-black-solid, #000);
  font-size: 18px;
  font-weight: 600;
  line-height: 28px;
}

.container {
  display: flex;
  gap: 24px;
  align-items: flex-start;

  .card__header .content__section__title {
    margin-bottom: 10px;
  }

  @media only screen and (max-width: 500px) {
    flex-direction: column;
  }
}

.content__section__copy {
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  font-family: @regular-font;
  color: #000;
}

.card {
  border: 1px solid #e8e8ea;
  border-radius: 4px;
  background-color: rgba(250, 250, 250, 1);
  display: flex;
  flex: 1;
  flex-direction: column;
}

.card__header {
  padding: 16px 16px 24px;
  background-color: #fff;
  border: 1px solid #e8e8ea;
  border-radius: 4px 4px 8px 8px;
  margin: -1px -1px 0;
  box-shadow: 0 4px 6px -4px rgba(0, 0, 0, 0.12);
}

.card__footer {
  display: flex;
  flex-direction: column;
  padding: 16px 16px 24px;
}

.card__header__tag {
  font-family: @regular-font;

  :global(.p-tag-value) {
    font-weight: 700;
    font-size: 14px;
  }
}
.card__footer__title {
  font-size: 14px;
  font-weight: 600;
  font-family: @regular-font;
  margin-bottom: 6px;
}

.card__list {
  padding-top: 6px;
  padding-left: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;

  margin: 0;
}

.card__list li {
  display: flex;
  align-items: center;
}

.card__list li i {
  color: #5b00f0;
  font-size: 14px;
  flex-shrink: 0;
}

.card__list li span {
  font-family: @regular-font;
  font-size: 14px;
  font-weight: 500;
  color: #000;
  margin-left: 14px;
}

@media (min-width: 900px) {
  .content {
    max-width: 600px;
  }
}
</style>
